import {tasksChildRouteElements, tasksFeatureTranslations} from '@features/tasks'
import {FeatureTranslationsLoader} from '@hconnect/common/localization-loaders'
import {InvertedSurfaceProvider} from '@hconnect/common/styles'
import React from 'react'
import {Outlet, Route} from 'react-router'

import {DefaultShell} from '../shared/layouts'
import {TASKS} from '../shared/routes'
import {Context} from '../shared/types'

const Wrapper: React.FC<{
  context: Context
}> = ({context}) => (
  <FeatureTranslationsLoader translations={tasksFeatureTranslations}>
    <DefaultShell context={context}>
      <InvertedSurfaceProvider>
        <Outlet />
      </InvertedSurfaceProvider>
    </DefaultShell>
  </FeatureTranslationsLoader>
)

export const getTasksRoutes = ({context}: {context: Context}) => {
  return (
    <Route path={TASKS} element={<Wrapper context={context} />}>
      {tasksChildRouteElements}
    </Route>
  )
}
